import { useContext } from 'react';
import { CXISetupContext } from './CXISetupContext';

export const useCXISetup = () => {
    const context = useContext(CXISetupContext);
    if (context === undefined) {
        throw new Error('useCXISetup must be used within a CXISetupContextProvider');
    }
    return context;
};
